import ENDPOINTS from 'tradera-constants/endpoints';
import qs from 'qs';

const specialSearchTerms = {
    stammisglaset: '/campaign/stammisglaset'
};

/**
 *
 * @param {string} searchTerm search term
 * @param {object} queryParams query paramters of the current page
 * @param {int} currentCategoryId id of the current selected category
 * @param {array} allCategories array with all the categories
 */
export const getNewSearchUrl = (
    searchTerm,
    queryParams,
    currentCategoryId,
    allCategories
) => {
    // Search with search term
    if (searchTerm) {
        // ----------------------------------
        // Special case redirects
        const specialTermUrl = specialSearchTerms[searchTerm.toLowerCase()];
        if (specialTermUrl) {
            return specialTermUrl;
        }

        // Filter out params not to pass on in query reformulation
        const {
            q,
            categoryId,
            paging,
            spage,
            ...filteredQueryParams
        } = queryParams;

        // Query reformulation = First "Nike" and then "Nike air" or the other way around
        const isQueryReformulation =
            searchTerm.includes(q) || (q && q.includes(searchTerm));

        return (
            ENDPOINTS.SEARCH +
            qs.stringify(
                {
                    // Keep
                    ...(isQueryReformulation ? filteredQueryParams : {}),
                    q: searchTerm,
                    categoryId: currentCategoryId
                        ? currentCategoryId
                        : undefined
                },
                {
                    addQueryPrefix: true
                }
            )
        );
    }

    if (currentCategoryId > 0) {
        // Search without search term, just category
        const currentCategory = allCategories.find(
            category => category.id === currentCategoryId
        );

        if (currentCategory) {
            return currentCategory.href;
        }
        return;
    }
    // Fall back to category page for empty search
    return '/kategorier';
};

/**
 *
 * @param {function} t translator function
 * @param {array} allCategories all categories
 * @param {array} categoryPath path to the current category. it's in the reverse order
 * @param {int} currentCategoryId id of the current category
 */
export const getCategoryDropdownConfig = (
    t,
    allCategories,
    categoryPath,
    currentCategoryId
) => {
    const allCategoriesOption = {
        id: 0,
        title: t('searchSelect_allCategories'),
        shortName: t('searchSelect_allCategoriesShortName')
    };

    const optionDivider = {
        id: 0,
        title: '------------------'
    };

    /**
     * Strip "all categories" (may be multiple) from categorypath
     * Add rest of categorypath
     * Add "all categories"
     * Add all level1 categories
     */
    const optionsList = [
        ...categoryPath.filter(category => category.id !== 0),
        allCategoriesOption,
        optionDivider,
        ...allCategories
    ];

    /**
     * Get selected category from list, fallback to "all categories"
     */
    const selectedOption =
        optionsList.find(category => category.id === currentCategoryId) ||
        allCategoriesOption;

    return {
        selectedOption,
        optionsList
    };
};

export const getNextIndex = (incrementBy, currentIndex, totalElements) => {
    if (currentIndex === null) {
        currentIndex = incrementBy > 0 ? -1 : 0;
    }

    let newIndex = currentIndex + incrementBy;
    if (newIndex < 0) {
        return totalElements - 1;
    }
    if (newIndex >= totalElements) {
        return 0;
    }
    return newIndex;
};
